<template>
  <div class="myOrder" :class="{'isiOSX':isiOSX}" :style="myOrderStyle">
    <nav-bar titleText="充值订单" fontColor="#333333" @goBack="goBack" bgc="#ffffff" :isFixed="true" :isIOSX="isiOSX"></nav-bar>
    <van-tabs v-model="active" line-width="20%" sticky>
      <van-tab title-style="flex-basis: 20%;" title="全部">
        <recharge-order-list :orderStatus="0" />
      </van-tab>
      <van-tab title-style="flex-basis: 20%;" title="待付款">
        <recharge-order-list :orderStatus="1" />
      </van-tab>
      <van-tab title-style="flex-basis: 20%;" title="正充值">
        <recharge-order-list :orderStatus="2" />
      </van-tab>
      <van-tab title-style="flex-basis: 20%;" title="已完成">
        <recharge-order-list :orderStatus="4" />
      </van-tab>
      <van-tab title-style="flex-basis: 20%;" title="已关闭">
        <recharge-order-list :orderStatus="5" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import rechargeOrderList from './components/rechargeOrderList'
import navBar from './components/navBar'
import Bus from "../../providers/eventBus"
export default {
  data() {
    return {
      active: 0,
      // status: 订单状态 1：待付款，2：正充值，3：充值失败，4：已完成，5：已关闭，查询所有则不传
      // status:'',
      // page:1,
      isiOSX: false,
      myOrderStyle: {
        'min-height': (document.body.clientHeight - 132) + 'px',
      },
      busRechargeDetailData: {},
    };
  },
  components: {
    rechargeOrderList,
    navBar,
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if(this.$route.query.token){
      this.$api.setToken(this.$route.query.token)
    }
    // if(! (this.$route.query.charge_from == 'home')){
    if(this.$route.query.from == 2){
      // alert(1)
      this.active = 2
    }
    if(this.$route.query.from == 1){
      // alert(2)
      this.active = 0
    }
    if(this.$route.query.from == 3){
      this.active = 5
    }
    Bus.$on('busRechargeDetail', this.handleBusRechargeDetail)
    
  },
  mounted(){
    if(this.$route.query.from == 2) {
    // if(true) {
      history.replaceState(null, '', '/recharge/rechargeHome');
      history.pushState(null, '', '/recharge/myOrder');
    }
  },
  methods: {
    handleBusRechargeDetail(data){
      if(data.charge_from == 'detail'){
        const _status = parseInt(data.orderStatus)
        if ([0,1,2].includes(_status)) {
          this.active = _status
        }
        if ([4,5].includes(_status)) {
          this.active = _status - 1
        }
      }
    },
    goBack() {
      if (this.$route.query.from == 1) {
        this.params("", "", "goBack")
      } else {
        this.$router.go(-1)
      }

    },
    
  },
  beforeDestroy() {
    Bus.$off('busRechargeDetail', this.handleBusRechargeDetail)
  },
};
</script>

<style lang="less">
.myOrder {
  // min-height: 588px;
  background-color: #F5F6F7;
  // padding-top: 152px;
  padding-top: 132px;
  .recharge-nav-bar {
    padding: 51px 0px 8px!important;
  }
  .van-tab {
    padding: 0 5px 0;
  }
  .van-tabs__line {
    height:2px;
    background:linear-gradient(270deg,rgba(249,89,27,0.2) 0%,rgba(249,89,27,1) 100%);
    border-radius:1px;
  }
  .van-tab__text {
    font-size: 16px;
    color: #666666;
  }
  .van-tab--active {
    .van-tab__text {
      font-weight: 500;
      color: #F9591B;
    }
  }

  .van-sticky{
	  position: fixed;
	  // top: 108px;
	  top: 88px;
	  width: 100%;
	  z-index: 2;
	  // border-bottom: solid 1px #EEEEEE;
  }
}

.isiOSX.myOrder {
    padding-top: 132px;
    .van-sticky{
	    top: 88px;
    }
}

</style>
